module.exports = __webpack_public_path__ + "static/media/pipe.0c1284bf.wav";